import { fromJS } from 'immutable';

import { REDIRECT_TO_LOGIN, RESET_REDIRECT } from './constants';

export const initialState = fromJS({
  redirectedFrom: '',
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case REDIRECT_TO_LOGIN:
      return state.set('redirectedFrom', action.url);
    case RESET_REDIRECT:
      return state.set('redirectedFrom', initialState.get('redirectedFrom'));

    default:
      return state;
  }
}

export default appReducer;
